<template lang="pug">
  WtEntityTable.teams-table(
    :title="title"
    entityType="team"
    :show-title="showTitle"
    :data="teamsData"
    default-sort-field="name"
    default-sort-direction="asc"
    :enable-search="enableSearch"
    :search-fields="searchFields"
    :enable-remove="enableRemove"
    :enable-add="enableAdd"
    :includeByType="includeByType"
    :loading="loading"
    @remove="unstageTeam($event)"
    @add="stageTeam($event)"
    @search="onTeamListSearch($event)"
    :empty-message="emptyMessage"
  )
    BTableColumn(field="name" label="Team Name" sortable v-slot="column")
      | {{ column.row.name }}
    BTableColumn(field="numMembers" label="# of Members" centered v-slot="column")
      | {{ column.row.numMembers }}
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import tablePropsMixin from "@/mixins/tablePropsMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";

const API = "api";
const RECEIVER = "receiver";

export default {
  name: "ChallengeBuilderTeamsTable",

  components: { WtEntityTable },

  mixins: [tablePropsMixin],

  props: {
    /**
     * set as `api` to fetch teams to populate table, set as `receiver`
     * to allow teams to be added to table
     */
    mode: {
      type: String,
      default: "api",
      validator(mode) {
        return [API, RECEIVER].indexOf(mode) !== -1;
      }
    },

    title: {
      type: String,
      default: "Team List:"
    },

    includeByType: {
      type: String,
      default: "invite"
    },

    notInChallengeId: {
      type: Number,
      default: 0
    },

    emptyMessage: {
      type: String,
      default: "No teams have been added yet"
    }
  },

  data() {
    return {
      teamsData: []
    };
  },

  computed: {
    ...mapGetters("program", ["programTeams"]),
    ...mapGetters("challengeBuilder", ["stagedTeams"])
  },

  async mounted() {
    if (this.mode === API) {
      const searchResp = await this.searchForTeams("");

      this.teamsData = searchResp.data;
    } else {
      this.teamsData = this.stagedTeams;
    }

    this.onTeamListSearch = this._.debounce(async query => {
      const searchResp = await this.searchForTeams(query);

      this.teamsData = searchResp.data;
    }, 500);
  },

  methods: {
    ...mapActions("challengeBuilder", ["unstageTeam", "stageTeam"]),
    ...mapActions("program", ["searchProgramTeams"]),
    onTeamListSearch() {},
    async searchForTeams(query) {
      return await this.searchProgramTeams({
        programId: this.$auth.user().programId,
        searchTerm: query,
        sortColumn: null,
        sortOrder: null,
        notInChallengeId: this.notInChallengeId,
        perPage: 10
      });
    }
  }
};
</script>

<style lang="sass">
.teams-table
  .team-td
    max-width: 150px
</style>
